import React from 'react';
import { Popover, PopoverButton, PopoverPanel } from '@headlessui/react';
import { PlusCircle } from 'react-feather';

import { useMe } from '../../../hooks/useMe';
import { useRefreshRoles } from '../../../hooks/useRoles';
import { ActionPanelBox, RefreshButton } from '../Components';
import { NewRoleEditCard } from './NewRoleEditCard';

export const ActionPanel: React.VFC = () => {
  const me = useMe();
  const refresh = useRefreshRoles();
  return (
    <ActionPanelBox>
      {me?.masterPermissions?.canCreateRole && (
        <Popover className="relative">
          <PopoverButton className="w-fit h-fit flex items-center gap-2 bg-darkblue_100 hover:bg-darkblue_70 rounded px-3 py-2">
            <PlusCircle size={24} className="text-white" />
            <span className="text-white font-bold text-lg">新規作成</span>
          </PopoverButton>
          <PopoverPanel className="absolute z-10 top-12">
            {({ close }) => <NewRoleEditCard onSubmit={() => close()} onCancel={() => close()} />}
          </PopoverPanel>
        </Popover>
      )}
      <RefreshButton onClick={() => refresh()} />
    </ActionPanelBox>
  );
};
